"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDepositProductNames = getDepositProductNames;
exports.isDefaultYieldOffer = isDefaultYieldOffer;
const onboarding_1 = require("./onboarding");
const MISSING_SOURCE_DEPOSIT_PRODUCT_NAMES = {
    depositProductName: 'Aven Checking',
    shortDepositProductName: 'Aven Checking',
};
const DEPOSIT_PRODUCT_NAMES_BY_SOURCE = {
    [onboarding_1.DepositOnboardingSource.DEFAULT]: {
        depositProductName: 'Aven High-Yield Checking',
        shortDepositProductName: 'High-Yield Checking',
    },
    [onboarding_1.DepositOnboardingSource.REWARDS_CHECKING_BUNDLE]: {
        depositProductName: 'Aven Rewards Checking',
        shortDepositProductName: 'Rewards Checking',
    },
    [onboarding_1.DepositOnboardingSource.FOREST_RIVER]: {
        depositProductName: 'Forest River Trailhead Deposit',
        shortDepositProductName: 'Forest River Checking',
    },
    [onboarding_1.DepositOnboardingSource.HOME_DEPOSIT_BUNDLE_HIGH_YIELD_CHECKING]: {
        depositProductName: 'Aven High-Yield Checking',
        shortDepositProductName: 'High-Yield Checking',
    },
};
function getDepositProductNames(source) {
    if (source == null) {
        return MISSING_SOURCE_DEPOSIT_PRODUCT_NAMES;
    }
    return DEPOSIT_PRODUCT_NAMES_BY_SOURCE[source];
}
function isDefaultYieldOffer(source, depositApyPercentage) {
    return source === onboarding_1.DepositOnboardingSource.DEFAULT && depositApyPercentage > 0;
}
